import {
  Button,
  Dialog,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import { IconTrash, IconX } from "@tabler/icons-react";
import { MutationFunction, useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "react-toastify";
import Loading from "./Loading";

const ModalConfirmWithButton = ({
  title = "",
  subtitle = "",
  buntonTitle = "",
  onAction,
  mutationFn,
}: {
  onAction: () => void;
  mutationFn: MutationFunction;
  title: string;
  subtitle: any;
  buntonTitle: string;
}) => {
  const [open, setOpen] = useState(false);

  const { mutate, isPending } = useMutation({
    mutationFn: mutationFn,
    onSuccess: () => {
      setOpen(false);
      onAction();
      toast.success("Processado com sucesso");
    },
    onError: (e: { response: { data: { message: string } } }) => {
      toast.error(
        String(e?.response?.data?.message) ||
          "Não conseguimos processar sua solicitação"
      );
    },
  });

  return (
    <>
      <Button
        variant="contained"
        endIcon={<IconTrash />}
        color="error"
        sx={{ fontSize: { xs: "12px", md: "14px" } }}
        onClick={() => {
          setOpen(true);
        }}
      >
        {buntonTitle}
      </Button>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Loading loading={isPending} />
        <DialogContent sx={{ backgroundColor: "secondary.main" }}>
          <Grid2 container spacing={2} padding={1}>
            <Grid2 size={{ xs: 10, md: 11 }}>
              <Typography variant="h2" fontSize={26} fontWeight={600}>
                {title}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 2, md: 1 }}>
              <IconButton
                onClick={() => {
                  setOpen(false);
                }}
              >
                <IconX style={styles.iconStyle} />
              </IconButton>
            </Grid2>
            <Grid2 size={12}>
              <Typography variant="subtitle1" color="secondary.contrastText">
                {subtitle}
              </Typography>
            </Grid2>
            <Grid2 size={12}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                sx={{ backgroundColor: "red" }}
                onClick={() => {
                  mutate({});
                }}
              >
                {buntonTitle}
              </Button>
            </Grid2>
          </Grid2>
        </DialogContent>
      </Dialog>
    </>
  );
};

const styles = {
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  iconStyle: {
    color: "primary.main",
  },
};

export default ModalConfirmWithButton;
